import { render, staticRenderFns } from "./TabShipments.vue?vue&type=template&id=a78b69e6&lang=pug&"
import script from "./TabShipments.vue?vue&type=script&lang=js&"
export * from "./TabShipments.vue?vue&type=script&lang=js&"
import style0 from "./TabShipments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports